export interface JoinWaitlistPayload {
  shopId: string;
  barberId?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  day: string; // Format: 'YYYY-MM-DD'
  serviceIds: string[];
  paymentToken?: string;
  paymentCardId?: string;
  tipAmount?: number;
  preferredLanguage?: string;
}

export interface JoinWaitlistResponse {
  id: string;
  shopId: string;
  barberId: string;
  customerId: string;
  day: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface WaitlistApiError {
  message: string;
  code: string;
  status?: number;
}

const WAITLIST_CONFLICT_STATUS = 409;
const WAITLIST_CONFLICT_CODE = 'Conflict';

export const isWaitlistConflictError = (
  error: unknown,
): error is WaitlistApiError =>
  typeof error === 'object' &&
  error !== null &&
  'code' in error &&
  ((error as WaitlistApiError).code === WAITLIST_CONFLICT_CODE ||
    ('status' in error &&
      (error as WaitlistApiError).status === WAITLIST_CONFLICT_STATUS));
